module.exports = {
  qqgdscpjypt:
    "Plataforma de comercio de productos acuáticos de gama alta global (y shenzhen international tuna trading co., LTD.)",
};



// WEBPACK FOOTER //
// ./src/lang/sp.js